(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Dispositivo', Dispositivo);

    Dispositivo.$inject = ['$resource'];

    function Dispositivo ($resource) {
        var resourceUrl =  'api/dispositivos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
